<template>
  <jade-list-item
    :label="transactionData.reason"
    :description="transactionData.amount"
    :thirdLine="transactionData.createdAt"
    @onClick="openChargebackDetails"
    navigation
  >
    <template slot="trailing">
      <div class="flex flex-col gap-1">
        <jade-text color="medium"> ID: {{ transactionData.id }} </jade-text>
        <jade-tag
          size="medium"
          :variant="transactionData.statusBadge"
        >
          {{ transactionData.statusLabel }}
        </jade-tag>
      </div>
    </template>
  </jade-list-item>
</template>
<script>
import { JadeListItem, JadeText, JadeTag } from '@jade'
import ChargebackManager from '../../chargeback.manager'
import ChargebackMassRepresentmentManager from '../chargeback-mass-representment.manager'

export default {
  name: 'TransactionItem',
  components: {
    JadeListItem,
    JadeTag,
    JadeText
  },
  props: {
    transaction: {
      type: Object,
      required: true
    }
  },
  computed: {
    transactionData () {
      return ChargebackMassRepresentmentManager.transactionAdapter(
        this.transaction
      )
    },

    statusBadge () {
      return ChargebackManager.chargebackStatusBadge(
        this.transactionData.statusCode
      )
    }
  },
  methods: {
    openChargebackDetails () {
      const { href } = this.$router.resolve({
        name: 'chargebackDetails',
        params: {
          chargeback_id: this.transactionData.id
        }
      })
      window.open(href, '_blank')
    }
  }
}
</script>
